import styled, { css } from 'styled-components';
import { em } from 'polished';
import { HeadingBase } from 'elements/Heading/styled';
import { colors } from 'core/theme';
import { media } from 'core/layout';

export const SimpleHairline = styled.hr`
  border: none;
  border-top: 1px solid ${colors.hairline};


  ${({main}) => main && css`
    margin-top:64px;
    margin-bottom:50px;

    ${media.tabletSmall`
      margin-top:32px;
      margin-bottom:25px;
    `};

    @media print {
      margin-top: 3em;
      margin-bottom: 2em;
    }
  `};


  ${({fat}) => fat && css`
    border-top: 4px solid ${colors.primaryDark};
    ${media.tablet`
      border-top: 2px solid ${colors.primaryDark};
    `};
  `};


`;

export const HairlineGroup = styled.div`
  display: flex;
  align-items: flex-end;
  margin-bottom: 48px;
  margin-top: 72px;

  & > div {
    color: ${colors.text};
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 24px;

    & > i {
      margin-bottom: 12px;

      & > svg {
        width: ${em(30)};
        height: ${em(30)};
      }
    }

    & > h1 {
      margin: 0;
    }
  }

  & > hr {
    flex: 1;
    margin-bottom: ${em(24)};
  }

  ${media.tablet`
    margin-bottom: 24px;
    margin-top: 36px;

    & > div {
      padding: 0 12px;

      & > i {
        margin-bottom: 6px;

        & > svg {
          width: ${em(24)};
          height: ${em(24)};
        }
      }
    }

    & > hr {
      margin-bottom: ${em(14)};
    }
  `};
`;

export const StyledHeading = HeadingBase.extend`
  ${media.tablet`
    font-size: ${em(24)};
  `};
`;



// WEBPACK FOOTER //
// ./src/elements/Hairline/styled.js